import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { getIconStyles as L } from "../styles.js";
const d = (e) => /* @__PURE__ */ l(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_3928_22219)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8397 9.10811C11.035 9.30337 11.035 9.61996 10.8397 9.81522L10.058 10.597L10.8398 11.3788C11.035 11.574 11.035 11.8906 10.8398 12.0859C10.6445 12.2811 10.3279 12.2811 10.1327 12.0859L9.3509 11.3041L8.56913 12.0859C8.37387 12.2811 8.05729 12.2811 7.86203 12.0859C7.66676 11.8906 7.66676 11.574 7.86202 11.3788L8.6438 10.597L7.86208 9.81523C7.66682 9.61996 7.66682 9.30338 7.86209 9.10812C8.05735 8.91286 8.37393 8.91286 8.56919 9.10813L9.3509 9.88985L10.1326 9.10812C10.3279 8.91286 10.6445 8.91285 10.8397 9.10811Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.1379 9.10811C16.3332 9.30337 16.3332 9.61996 16.1379 9.81522L15.3562 10.597L16.138 11.3788C16.3332 11.574 16.3332 11.8906 16.138 12.0859C15.9427 12.2811 15.6261 12.2811 15.4309 12.0859L14.6491 11.3041L13.8673 12.0859C13.6721 12.2811 13.3555 12.2811 13.1602 12.0859C12.965 11.8906 12.965 11.574 13.1602 11.3788L13.942 10.597L13.1603 9.81523C12.965 9.61996 12.965 9.30338 13.1603 9.10812C13.3555 8.91286 13.6721 8.91286 13.8674 9.10813L14.6491 9.88985L15.4308 9.10812C15.6261 8.91286 15.9426 8.91285 16.1379 9.10811Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M10 14.5C10 14.2239 10.2239 14 10.5 14H13.5C13.7761 14 14 14.2239 14 14.5C14 14.7761 13.7761 15 13.5 15H10.5C10.2239 15 10 14.7761 10 14.5Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.13348 9.27849C-0.367411 10.7794 -0.367411 13.2128 1.13348 14.7137L9.2863 22.8665C10.7872 24.3674 13.2206 24.3674 14.7215 22.8665L22.8743 14.7137C24.3752 13.2128 24.3752 10.7794 22.8743 9.27849L14.7215 1.12567C13.2206 -0.375223 10.7872 -0.375223 9.2863 1.12567L1.13348 9.27849ZM12 17.9961C15.3137 17.9961 18 15.3098 18 11.9961C18 8.68239 15.3137 5.99609 12 5.99609C8.68629 5.99609 6 8.68239 6 11.9961C6 15.3098 8.68629 17.9961 12 17.9961ZM10.8397 9.81522C11.035 9.61996 11.035 9.30337 10.8397 9.10811C10.6445 8.91285 10.3279 8.91286 10.1326 9.10812L9.3509 9.88985L8.56919 9.10813C8.37393 8.91286 8.05735 8.91286 7.86209 9.10812C7.66682 9.30338 7.66682 9.61996 7.86208 9.81523L8.6438 10.597L7.86202 11.3788C7.66676 11.574 7.66676 11.8906 7.86203 12.0859C8.05729 12.2811 8.37387 12.2811 8.56913 12.0859L9.3509 11.3041L10.1327 12.0859C10.3279 12.2811 10.6445 12.2811 10.8398 12.0859C11.035 11.8906 11.035 11.574 10.8398 11.3788L10.058 10.597L10.8397 9.81522ZM16.1379 9.81522C16.3332 9.61996 16.3332 9.30337 16.1379 9.10811C15.9426 8.91285 15.6261 8.91286 15.4308 9.10812L14.6491 9.88985L13.8674 9.10813C13.6721 8.91286 13.3555 8.91286 13.1603 9.10812C12.965 9.30338 12.965 9.61996 13.1603 9.81523L13.942 10.597L13.1602 11.3788C12.965 11.574 12.965 11.8906 13.1602 12.0859C13.3555 12.2811 13.6721 12.2811 13.8673 12.0859L14.6491 11.3041L15.4309 12.0859C15.6261 12.2811 15.9427 12.2811 16.138 12.0859C16.3332 11.8906 16.3332 11.574 16.138 11.3788L15.3562 10.597L16.1379 9.81522ZM10 14.5C10 14.2239 10.2239 14 10.5 14H13.5C13.7761 14 14 14.2239 14 14.5C14 14.7761 13.7761 15 13.5 15H10.5C10.2239 15 10 14.7761 10 14.5Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_3928_22219", children: /* @__PURE__ */ C("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  d as DiamondDeadIcon
};
//# sourceMappingURL=DiamondDeadIcon.js.map
